import api from "../../../core/api";
import type { Location } from "../components/locations/locationTypes";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
};

export interface CreateLocationViewModel {
  name: string;
  parentLocationId?: string;
  description?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  countryId?: number;
  zipCode?: string;
}

export interface ChangeLocationViewModel {
  name: string;
  parentLocationId?: string;
  description?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  countryId?: number;
  zipCode?: string;
}

class CustomerLocationsApi {
  getLocations(): Promise<Location[]> {
    return api
      .get<Location[]>(`/v1/locations`, getRequestConfig())
      .then((x) => x.data);
  }

  getLocation(id: string): Promise<Location> {
    return api
      .get<Location>(`/v1/locations/${id}`, getRequestConfig())
      .then((x) => x.data);
  }

  createLocation(data: CreateLocationViewModel): Promise<string> {
    return api
      .post<string>(`/v1/locations`, data, getRequestConfig())
      .then((x) => x.data);
  }

  updateLocation(id: string, data: ChangeLocationViewModel): Promise<void> {
    return api
      .put<void>(`/v1/locations/${id}`, data, getRequestConfig())
      .then(() => {});
  }

  disableLocation(id: string): Promise<void> {
    return api
      .delete(`/v1/locations/${id}`, getRequestConfig())
      .then(() => {});
  }

  setDefaultLocation(id: string): Promise<void> {
    return api
      .post(`/v1/locations/${id}/set-default`, null, getRequestConfig())
      .then(() => {});
  }
}

export default new CustomerLocationsApi();
